import {IChangeTracking} from './iChangeTracking';
import {IChangeTrackingService} from './iChangeTrackingService';

export class ChangeTrackingService implements IChangeTrackingService {
    scopeWithChangeTracking: IChangeTracking;
    trackedStateName: string;

    static $inject = ['$state', '$rootScope', '$mdDialog'];

    constructor(private $state: ng.ui.IStateService,
        private $rootScope: ng.IRootScopeService,
        private $mdDialog: ng.material.IDialogService) {

        $rootScope.$on('$stateChangeStart', (event, toState, toParams, fromState, fromParams) => {
            if (toState.name !== 'login') {
                if (this.hasChanges(fromState.name)) {
                    event.preventDefault();
                    this.showDiscardChangesPromptAndChangeState(toState.name, toParams);
                }
            }
        });
    }

    initializeTracking(scopeWithChangeTracking: IChangeTracking) {
        this.trackedStateName = this.$state.current.name;
        this.scopeWithChangeTracking = scopeWithChangeTracking;
    }

    hasChanges(fromStateName: string): boolean {
        return fromStateName === this.trackedStateName
            && this.scopeWithChangeTracking
            && this.scopeWithChangeTracking.hasChanges();
    }

    resetChanges() {
        this.trackedStateName = undefined;
        this.scopeWithChangeTracking = undefined;
    }

    showDiscardChangesPromptAndChangeState(toStateName: string, toStateParams: {}): void {
        this.showDiscardChangesDialog(toStateName, toStateParams).then(
            () => {
                this.resetChanges();
                this.$state.go(toStateName, toStateParams);
            },
            () => {
                this.$rootScope.$broadcast('$stateChangeError');
            }
        );
    }

    showDiscardChangesDialog(toState: string, toStateParams: {}): angular.IPromise<any> {
        const confirm = this.$mdDialog.confirm()
            .textContent('Discard pending changes?')
            .ok('Discard')
            .cancel('Cancel');
        return this.$mdDialog.show(confirm);
    }
}


/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/features/changeTracking/changeTracking.service.ts
 **/